<template>
  <KTPortlet title="Заказы">
    <div slot="toolbar">
      <v-btn color="info" type="button" class="mr-1" @click="openMap"
        >Техника на карте города</v-btn
      >
      <v-btn color="primary" type="button" @click="newOrder">Новый заказ</v-btn>
    </div>
    <div slot="body">
      <order-dialog ref="dialog" @submitted="fetchData" />
      <v-data-table :headers="fields" :items="orders" :items-per-page="15">
        <template v-slot:item.date="data">{{
          formatDateTime(data.item.date)
        }}</template>
        <template v-slot:item.payment_type="data">
          <span
            class="badge badge-success badge-inline"
            v-if="data.item.payment_type == 'non_cash'"
            >Безналичный</span
          >
          <span class="badge badge-info badge-inline" v-else>Наличными</span>
        </template>
        <template v-slot:item.status="data">
          <span class="badge badge-inline">{{
            statuses[data.item.status]
          }}</span>
        </template>
        <template v-slot:item.action="data">
          <div v-if="data.item.status === 'rough_draft'" class="d-flex">
            <v-btn
              class="mr-1"
              color="primary"
              title="Изменить"
              @click="() => updateOrder(data.item)"
              ><i class="fa fa-pencil-alt text-white"></i
            ></v-btn>
            <v-btn
              class="mr-1"
              color="warning"
              title="Копировать"
              @click="() => copyOrder(data.item)"
              ><i class="fa fa-copy text-white"></i
            ></v-btn>
            <v-btn
              color="error"
              title="Удалить"
              @click="() => removeOrder(data.item)"
              ><i class="fa fa-times text-white"></i
            ></v-btn>
          </div>
          <div v-else>
            <v-btn
              class="mr-1"
              color="info"
              title="Просмотр"
              @click="() => showOrder(data.item)"
              ><i class="fa fa-file text-white"></i
            ></v-btn>
            <v-btn
              class="mr-1"
              color="warning"
              title="Копировать"
              @click="() => copyOrder(data.item)"
              ><i class="fa fa-copy text-white"></i
            ></v-btn>
          </div>
        </template>
      </v-data-table>
    </div>
  </KTPortlet>
</template>

<script>
import KTPortlet from "@/view/content/Card.vue";
import OrderDialog from "@/view/pages/client/orders/OrderDialog.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import moment from "moment";
moment.locale("ru");

export default {
  name: "orders",
  metaInfo: {
    title: "Заказы",
  },
  components: { KTPortlet, OrderDialog },
  data() {
    return {
      loading: false,
      orders: [],
      vehicles: [],
      modalShow: false,
      currentOrder: null,
      statuses: {
        rough_draft: "Черновик",
        in_process: "В обработке",
        in_work: "В работе",
        done: "Выполнен",
        not_done_by_implementer: "Отказ исполнителя",
        not_done_by_customer: "Отказ заказчика",
        paid: "Оплачен",
        canceled: "Отменен",
      },
      fields: [
        {
          value: "canonical_id",
          text: "№ заказа",
        },
        {
          value: "address",
          text: "Адрес",
        },
        {
          value: "responsible_person",
          text: "Ответственное лицо",
        },
        {
          value: "vehicle_type.name",
          text: "Тип техники",
        },
        {
          value: "date",
          text: "Дата",
        },
        {
          value: "payment_type",
          text: "Способ оплаты",
        },
        {
          value: "description",
          text: "Описание",
        },
        {
          value: "status",
          text: "Статус",
        },
        {
          value: "action",
          text: "",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Заказы" }]);
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$api["client/orders"]
        .select()
        .then((response) => {
          this.orders = response.data.items;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDateTime(time) {
      return moment(time).format("DD.MM.YYYY HH:mm");
    },
    openMap() {
      this.$router.push({ path: "/client/map" });
    },
    newOrder() {
      this.$refs.dialog.open();
    },
    updateOrder(item) {
      this.$api["client/orders"]
        .find(item.id)
        .then((response) => {
          this.$refs.dialog.open(response.data);
        })
        .catch((error) => {
          this.$toast.error(error.response.data.errors.base.join(", "), {
            icon: "fa-exclamation-circle",
          });
        });
    },
    copyOrder(item) {
      this.$api["client/orders"]
        .find(item.id)
        .then((response) => {
          delete response.data.id;
          this.$refs.dialog.open(response.data);
        })
        .catch((error) => {
          this.$toast.error(error.response.data.errors.base.join(", "), {
            icon: "fa-exclamation-circle",
          });
        });
    },
    showOrder(item) {
      this.$api["client/orders"]
        .find(item.id)
        .then((response) => {
          this.$refs.dialog.open(response.data, true);
        })
        .catch((error) => {
          this.$toast.error(error.response.data.errors.base.join(", "), {
            icon: "fa-exclamation-circle",
          });
        });
    },
    async removeOrder(item) {
      const res = await this.$confirm(
        "Вы действительно хотите удалить заказ?",
        {
          title: "Предупреждение",
          buttonTrueText: "Да, удалить",
          buttonFalseText: "Нет",
          icon: "fa-exclamation-circle",
        }
      );
      if (res) {
        this.$api["client/orders"]
          .delete(item.id)
          .then(() => {
            this.$toast.success("Операция выполнена.");
            this.fetchData();
          })
          .catch((error) => {
            this.$toast.error(error.response.data.errors.base.join(", "), {
              icon: "fa-exclamation-circle",
            });
          });
      }
    },
  },
};
</script>
